/**
 * Shown when the CIAM tenant details have not been supplied yet. Lets the app
 * be built and deployed before the identity tenant exists, without the first
 * visitor meeting a stack trace.
 */
export function NotConfigured() {
    return (
        <div className="app">
            <header className="masthead">
                <h1>Lowe&rsquo;s Store Counts</h1>
                <p>Setup incomplete</p>
            </header>
            <div className="content">
                <div className="alert alert-error">
                    <h3>Sign-in is not configured</h3>
                    <p style={{ margin: 0 }}>
                        This deployment is missing its identity settings, so nobody can sign
                        in yet.
                    </p>
                </div>
                <p>
                    Set <code>CIAM_CLIENT_ID</code> and <code>CIAM_TENANT_SUBDOMAIN</code> as
                    App Service application settings and restart. No rebuild needed - the app
                    reads them at runtime from <code>/config.json</code>.
                </p>
            </div>
        </div>
    );
}
